import React from 'react'
import { t } from 'ttag'

const BudgetRoundCost = ({
  value,
  currentRound,
  onMoveNext,
  onUpdateValue,
  rounds,
  isSubmitting
}) => {
  const roundList = []
  const nextR = rounds
    .filter(r => r.visibleMenu)
    .find(r => r.roundId === currentRound + 1)

  roundList.push(
    nextR
      ? nextR
      : {
          id: 'total',
          name: t`Total`
        }
  )

  return (
    <div className="total">
      <form action="javascript://">
        <div className="monthlycosts budget-summary">
          <label htmlFor="monthlycost">
            <span>{t`Monthly Cost`}</span>
          </label>
          <div className="input-group">
            <span className="input-group-addon">$</span>
            <input
              type="text"
              id="monthlycost"
              className="text-input response"
              onChange={v => onUpdateValue(v.target.value)}
              value={value}
            />
          </div>
        </div>
        <div id="navaction">
          <input
            type="submit"
            onClick={onMoveNext}
            disabled={value === '' || isSubmitting}
            className="btn btn-success btn-cta-lg"
            value={t`Next Section`}
          />
          {roundList.map(r => (
            <div className="nextsection" key={r.id}>
              <div className={`withicons icon ${r.id}icon`}></div>
              <div className="name">{r.name}</div>
            </div>
          ))}
        </div>
      </form>
    </div>
  )
}

export default BudgetRoundCost
